import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Typography, CircularProgress } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Button, Modal } from "antd";

import "../../styles/creditCardPayment.css";
import "../../styles/checkOut.css";
import Header from "../../components/Header/Header.js";
import NtarLogo from "../../assets/Images/webntarbizzlogo.svg";
import { ImagesPath } from "../../Common/imagespath/imagespath.js";
import { useLocationPermission } from "../../Common/creditCardBinAPI/useLocation.js";
import {
  generateTransactionId,
  getPaymentStatus,
  validateDetails,
} from "../../Common/creditCardBinAPI/CommonFunctions.js";
import { getUserDetailsByToken } from "../../components/ReusebleComponents/ResuseableApiCalls";
import {
  FetchingCardLimitDetails,
  FetchWalletSchemeDetails,
  handleFetchPaymentIntegration,
  handleFetchPaymentIntegrationDummy,
  handleGetPayUPaymentStatus,
  handleGetSeamlessPaymentStatus,
  handleGetWebViewPaymentStatus,
  VerifyCreditCardNumber,
  verifyPluralPayment,
} from "../../components/GetPaid/CheckingDeatils";
import Receipt from "../../components/NewReceipt/Receipt.js";
import NtarLoader from "../../components/Loaders/NtarLoader.jsx";
import EnablePopupsGuide from "../../Common/Message/allowpopup.jsx";

const EducationPaycheckout = () => {
  const location = useLocation();
  const cardDetails = location.state || {};
  console.log(cardDetails);
  const navigate = useNavigate();

  const [accountDetailsOpen, setAccountDetailsOpen] = useState(true);
  const [cardDetailsOpen, setCardDetailsOpen] = useState(true);

  const [enteredDetails, setEnteredDetails] = useState({
    serviceName: cardDetails?.serviceName || "Educational",
    subService: cardDetails?.subService || "Educational",
    creditCardNumber: "XXXXXXXXXXXXXXXX",
    monthAndYear: "",
    cvv: "",
    mobileNumber: "",
    holderName: "",
    actualAmount: cardDetails?.amount || cardDetails?.actualAmount || "",
    paymentSource: "webApp",
    userDetails: {},
  });

  const [fieldErrors, setFieldErrors] = useState({});
  const [errorMessages, setErrorMessages] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [receiptData, setReceiptData] = useState(null);
  const [receiptModal, setReceiptModal] = useState(false);
  const [brand, setBrand] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [verfiedCardDetails, setVerfiedCardDetails] = useState({});
  const [showCvv, setShowCvv] = useState(false);
  const [cardError, setCardError] = useState("");
  const [enablePopups, setEnablePopups] = useState(false);
  const [receiptLoading, setReceiptLoading] = useState(false);
  const [pluralLoading, setPluralLoading] = useState(false);
  const [locationPermissionGiven, setLocationPermissionGiven] = useState(null);
  const [userDetails, setUserDetails] = useState(null);

  const {
    locationAccess,
    locationOfUser,
    permissionStatus,
    browserPermission,
    loadingLocation,
    locationError,
    ipAddress,
  } = useLocationPermission();

  const currentDate = new Date();
  const [currentMonth, currentYear] = [
    currentDate.getMonth() + 1,
    currentDate.getFullYear() % 100,
  ];

  useEffect(() => {
    if (loadingLocation) {
      return;
    }

    if (permissionStatus === "denied" || browserPermission === "denied") {
      setLocationPermissionGiven(false);
    } else if (locationAccess && locationOfUser) {
      setLocationPermissionGiven(true);
    } else {
      setLocationPermissionGiven(false);
    }
  }, [
    permissionStatus,
    locationAccess,
    locationOfUser,
    browserPermission,
    loadingLocation,
  ]);

  const handleGetUserDetails = async () => {
    try {
      const validUserDetails = await getUserDetailsByToken();
      console.log("validUserDetails==>>>>", validUserDetails);
      if (validUserDetails) {
        const { userimage, ...rest } = validUserDetails || {};
        setUserDetails(validUserDetails);
        setEnteredDetails((prev) => ({
          ...prev,
          mobileNumber:
            prev.mobileNumber || validUserDetails?.mobileNumber || "",
          userDetails: { ...rest },
        }));
      }
    } catch (error) {
      console.log("error in handleGetUserDetails ==>", error);
    }
  };

  useEffect(() => {
    handleGetUserDetails();
  }, []);

  const checkPaymentStatus = async (storedData) => {
    if (!storedData) return;

    const parsedData = JSON.parse(storedData);
    const orderId = parsedData?.orderId;
    const paymentId = parsedData?.paymentId;
    let statusData;
    setReceiptLoading(true);
    try {
      if (
        parsedData?.body?.paymentGateWay
          ?.toUpperCase()
          .includes("CASHFREEWEBVIEW")
      ) {
        statusData = await handleGetWebViewPaymentStatus(
          orderId,
          paymentId,
          parsedData,
        );
      } else if (parsedData?.paymentGateWay?.toUpperCase().includes("PAYU")) {
        statusData = await handleGetPayUPaymentStatus(
          parsedData?.transactionId,
          parsedData,
        );
      } else {
        statusData = await handleGetSeamlessPaymentStatus(
          orderId,
          paymentId,
          parsedData,
        );
      }

      console.log("parsedData===>>>>", parsedData);
      console.log("statusData===>>>>", statusData);

      if (statusData?.payInStatus) {
        setReceiptModal(true);
        setReceiptData(statusData);
      }
    } catch (error) {
      console.error("Error checking payment status:", error);
    } finally {
      setReceiptLoading(false);
    }
  };

  useEffect(() => {
    const storedCashfreeData = localStorage.getItem("cashfreeWebData");
    const storedCashfreeSeamlessData = localStorage.getItem("cashfreeWebData");
    const payUData = localStorage.getItem("payUData");
    if (storedCashfreeData) {
      checkPaymentStatus(storedCashfreeData);
    } else if (storedCashfreeSeamlessData) {
      checkPaymentStatus(storedCashfreeSeamlessData);
    } else if (payUData) {
      checkPaymentStatus(payUData);
    }
  }, []);

  const formatCreditCardNumber = (number) => {
    return number.replace(/\D/g, "").replace(/(\d{4})(?=\d)/g, "$1 ");
  };

  const moveToNextField = (field) => {
    const keys = [
      "creditCardNumber",
      "monthAndYear",
      "cvv",
      "mobileNumber",
      "holderName",
    ];

    const index = keys.findIndex((element) => element === field);

    if (index >= 0 && index < keys.length - 1) {
      const nextField = keys[index + 1];
      const nextFieldElement = document.getElementById(nextField);
      if (nextFieldElement) {
        nextFieldElement.focus();
      }
    }
  };

  const handleInputChange = (field, value) => {
    setErrorMessages([]);
    if (field === "creditCardNumber") {
      setCardError("");
      setBrand("");
      setCardNumber("");
    }

    let holderNameValue;
    let cvvValue;

    if (field === "holderName") {
      holderNameValue = value.replace(/[^A-Za-z\s]/g, "");
    }

    if (field === "cvv") {
      cvvValue = value.replace(/[^0-9]/g, "");
    }

    const rawValue = value.replace(/\s/g, "").replace(/\D/g, "");

    const updatedValue =
      field === "creditCardNumber"
        ? rawValue
        : field === "holderName"
          ? holderNameValue
          : field === "cvv"
            ? cvvValue
            : value;

    setEnteredDetails((prev) => ({
      ...prev,
      [field]: updatedValue,
    }));

    const newErrors = { ...fieldErrors };

    switch (field) {
      case "creditCardNumber":
        if (updatedValue === "") {
          delete newErrors.creditCardNumber;
        } else if (/^\d{16}$/.test(updatedValue)) {
          delete newErrors.creditCardNumber;
        } else {
          newErrors.creditCardNumber =
            "Credit Card Number should be 16 digits.";
        }
        break;

      case "cvv":
        if (updatedValue === "") {
          delete newErrors.cvv;
        } else if (/^\d{3}$/.test(updatedValue)) {
          delete newErrors.cvv;
        } else {
          newErrors.cvv = "CVV should be 3 digits.";
        }
        break;

      case "mobileNumber":
        if (updatedValue === "") {
          delete newErrors.mobileNumber;
        } else if (/^[6-9]\d{9}$/.test(updatedValue)) {
          delete newErrors.mobileNumber;
        } else {
          newErrors.mobileNumber =
            "Please enter a valid 10-digit mobile number starting with 6, 7, 8, or 9";
        }
        break;

      case "holderName":
        if (updatedValue === "") {
          delete newErrors.holderName;
        } else if (updatedValue.trim() !== "") {
          delete newErrors.holderName;
        } else {
          newErrors.holderName = "Name on Credit Card is required.";
        }
        break;

      case "monthAndYear":
        if (updatedValue === "") {
          delete newErrors.monthAndYear;
        } else {
          const match = updatedValue.match(/^(\d{2})\/(\d{2})$/);
          if (match) {
            const month = parseInt(match[1], 10);
            if (month >= 1 && month <= 12) {
              delete newErrors.monthAndYear;
            } else {
              newErrors.monthAndYear = "Month must be between 01 and 12.";
            }
          } else {
            newErrors.monthAndYear = "Expiration date must be in MM/YY format.";
          }
        }
        break;

      default:
        break;
    }

    setFieldErrors(newErrors);
  };

  const validateCreditCard = async (cardNum) => {
    if (cardNum?.length === 16) {
      const verfiedCardDetails = await VerifyCreditCardNumber(
        enteredDetails?.creditCardNumber,
        {},
      );
      console.log("verfiedCardDetailsssss====>>>>", verfiedCardDetails);

      if (verfiedCardDetails.is_valid) {
        setVerfiedCardDetails(verfiedCardDetails);
        setBrand(verfiedCardDetails?.issuer_info?.Brand);
        const text = verfiedCardDetails?.issuer_info?.Issuer;
        const regex = /^(.*?),\s*LTD\.$/;
        const match = text?.match(regex);
        if (match) {
          setCardNumber(match[1]);
        } else {
          setCardNumber(text);
        }
      } else {
        setCardError("Please Check your card Details once again and Try");
        return;
      }
    } else {
      console.log("Invalid card number");
    }
  };

  const submitPayUFormInSameTab = (htmlString) => {
    document.open();
    document.write(htmlString);
    document.close();
  };

  const openPopup = (challengeUrl, orderId) => {
    setPluralLoading(true);
    const newWindow = window.open(
      challengeUrl,
      "_blank",
      `width=500,height=600,left=${(window.screen.width - 500) / 2},top=${
        (window.screen.height - 600) / 2
      }`,
    );
    if (!newWindow) {
      alert("Popup blocked! Please allow popups for this site.");
      return;
    }
    let hasCheckedStatus = false;
    const interval = setInterval(async () => {
      if (newWindow.closed && !hasCheckedStatus) {
        console.log("Payment popup closed.");
        hasCheckedStatus = true;
        clearInterval(interval);
        setLoading(false);

        if (orderId) {
          try {
            const res = await verifyPluralPayment({ order_id: orderId });
            console.log("resssss===>>>>", res);

            if (res?.status) {
              setReceiptData(res?.trasaction);
              setReceiptModal(true);
              setLoading(false);
            } else {
              setReceiptData(res?.trasaction);
              setReceiptModal(true);
              setLoading(false);
            }
          } catch (error) {
            console.error("Error fetching payment status:", error);
            setErrorMessages((prev) => [...prev, "Payment status unknown"]);
            setReceiptModal(true);
          } finally {
            setPluralLoading(false);
          }
        }
      }
    }, 1000);
  };

  const handleDummyAddMoney = async () => {
    console.log(":fire: Dummy user triggered Add Money");
    const ntarTransactionId = generateTransactionId();
    let finalObj = {};

    finalObj = {
      ...enteredDetails,
      ...cardDetails,
      paymentGateWay: "CASHFREE_FERRY", // paymentGateWay: "PAYU",
      payIngateWay: "CASHFREE_FERRY", // payIngateWay: "PAYU",
      payInRequired: "YES",
      transactionType: "Credit",
      finalPayableAmount: Number(cardDetails?.amount) + 2,
      amount: Number(cardDetails?.amount),
      ntarTransactionId,
      paymentSource: "webappDummy"
    };

    console.log("finalObj =====>>>", finalObj);

    const dummyResponse = await handleFetchPaymentIntegrationDummy(finalObj);

    if (dummyResponse?.payUrl) {
      window.location.href = dummyResponse?.payUrl;
    }
  };

  const handleAddMoneyCardToWallet = async () => {
    const errors = validateDetails(currentYear, currentMonth, enteredDetails);
    if (errors.length > 0) {
      setErrorMessages(errors);
      return;
    }
    setErrorMessages([]);
    setLoading(true);
    console.log("enteredDetails==>>", enteredDetails);
    if (verfiedCardDetails?.issuer_info?.Type?.toLowerCase() == "debit") {
      setCardError("You can't use this card");
      setLoading(false);
      return;
    }
    const moreDetails = {
      ...enteredDetails,
      cardType: "creditCard",
      paymentType:
        verfiedCardDetails?.issuer_info?.Category &&
        verfiedCardDetails?.issuer_info?.Category?.includes("BUSINESS")
          ? "corporatecreditcard"
          : "normalCreditCard",
      paymentMode: "creditCard",
      paymentMethod: verfiedCardDetails?.issuer_info?.Brand?.toLowerCase(),
      bankCode: verfiedCardDetails?.issuer_info?.Issuer?.split(" ")[0],
      CreditCardType: verfiedCardDetails?.issuer_info?.Type,
    };

    console.log("More verfiedCardDetails is this", verfiedCardDetails);
    console.log("More Details is this", moreDetails);
    try {
      const CheckingCreditCardLimit = await FetchingCardLimitDetails(
        enteredDetails?.subService,
        enteredDetails?.creditCardNumber,
        moreDetails,
        enteredDetails?.mobileNumber,
      );

      if (CheckingCreditCardLimit?.message === "valid") {
        const walletSchemeDetails = await FetchWalletSchemeDetails(moreDetails);
        console.log("this is walletScheme Details data:", walletSchemeDetails);
        // const creditCardServices = walletSchemeDetails?.status
        //   ? walletSchemeDetails?.data?.charges?.[0]
        //   : false;

        //   const creditCardServices = {
        //     serviceName: "PayIn",
        //     subService: "PRO[T+1]",
        //     bankName: "All",
        //     paymentGateWay: "PAYU1",
        //     paymentMode: "creditCard",
        //     paymentMethod: "visa",
        //     paymentType: "normalCreditCard",
        //     utilityType: "NoUtility",
        //     payInFee: 0,
        //     settleMentTime: "Instant",
        //     payOutFee: 0,
        //     PayInPercentage: "-1.43",
        //     payOutPercentage: 0,
        //     commissionPercentage: 0,
        //     commissionFee: 0,
        //     academicYear: 2025,
        //     createdDate: "16/09/2025",
        //     status: "Active",
        //   };
        //   console.log(
        //     "creditCardServices==>",
        //     JSON.stringify(creditCardServices),
        //   );

        //   if (creditCardServices) {
        //     const processingFee = !isNaN(parseFloat(creditCardServices?.payInFee))
        //       ? parseFloat(creditCardServices.payInFee)
        //       : 0;

        //     const processingPercentage = !isNaN(
        //       parseFloat(creditCardServices?.PayInPercentage),
        //     )
        //       ? parseFloat(creditCardServices.PayInPercentage)
        //       : 0;

        //     const actualAmount = !isNaN(Number(enteredDetails?.actualAmount))
        //       ? Number(enteredDetails.actualAmount)
        //       : 0;

        //     const charges = actualAmount * (processingPercentage / 100);

        //     const newAmount =
        //       processingFee > 0
        //         ? actualAmount - processingFee
        //         : actualAmount - charges;

        //     const finalObj = {
        //       ...enteredDetails,
        //       ...moreDetails,
        //       finalPayableAmount: !isNaN(newAmount)
        //         ? Number(newAmount)?.toFixed(2)
        //         : "0.00",
        //       chargedAmount: !isNaN(charges) ? charges.toFixed(2) : "0.00",
        //       processingFee: !isNaN(processingFee)
        //         ? processingFee.toFixed(2)
        //         : "0.00",
        //       processingPercentage: !isNaN(processingPercentage)
        //         ? processingPercentage.toFixed(2)
        //         : "0.00",
        //       settlementType: creditCardServices?.settleMentTime,
        //       paymentGateWay: creditCardServices?.paymentGateWay,
        //       payInRequired: "YES",
        //       paymentMode: "Credit Card",
        //       transactionType: "Credit",
        //       walletSettlementRequired: "NO",
        //       commissionPercentage: creditCardServices?.commissionPercentage,
        //       latitude: locationAccess ? locationOfUser.lat : null,
        //       longitude: locationAccess ? locationOfUser.lng : null,
        //       ipAddress: ipAddress,
        //       commissionFee: creditCardServices?.commissionFee || 0,
        //       referredBy: enteredDetails?.userDetails?.referredBy,
        //       userName: enteredDetails?.userDetails?.userName,
        //     };

        //     console.log("finalObj=====>>>>>", finalObj);

        //     if (newAmount > 0) {
        //       if (finalObj?.paymentGateWay) {
        //         const integrateRazorPay =
        //           await handleFetchPaymentIntegration(finalObj);

        //         console.log("integrateRazorPay=====>>>", integrateRazorPay);
        //         if (!integrateRazorPay || integrateRazorPay?.gatewayError) {
        //           setLoading(false);
        //           setIsModalVisible(true);
        //           return;
        //         }
        //         if (
        //           integrateRazorPay.status &&
        //           !integrateRazorPay?.checkoutUrl &&
        //           integrateRazorPay?.data
        //         ) {
        //           setReceiptData(integrateRazorPay?.data);
        //           setReceiptModal(true);
        //           setLoading(false);
        //         } else if (
        //           integrateRazorPay?.message?.toLowerCase().trim() ===
        //           "please check your card details or try again"
        //         ) {
        //           setLoading(false);
        //           setErrorMessages([integrateRazorPay?.message]);
        //         } else if (integrateRazorPay?.redirectUrl) {
        //           window.location.href = integrateRazorPay?.redirectUrl;
        //         } else if (integrateRazorPay?.PayUResp?.paymentURL) {
        //           submitPayUFormInSameTab(
        //             integrateRazorPay?.PayUResp?.paymentURL,
        //           );
        //         } else if (integrateRazorPay?.checkoutUrl) {
        //           openPopup(
        //             integrateRazorPay.checkoutUrl,
        //             integrateRazorPay?.orderResponse?.order_id,
        //           );
        //         } else if (integrateRazorPay?.payUrl) {
        //           window.location.href = integrateRazorPay?.payUrl;
        //         } else if (
        //           !integrateRazorPay.status &&
        //           integrateRazorPay?.message &&
        //           !integrateRazorPay?.data
        //         ) {
        //           setErrorMessages((prev) => [
        //             ...prev,
        //             integrateRazorPay?.message ||
        //               "Something went wrong, try again.",
        //           ]);
        //           setLoading(false);
        //         } else {
        //           setReceiptData(integrateRazorPay?.data);
        //           setReceiptModal(true);
        //           setLoading(false);
        //         }
        //       } else {
        //         setErrorMessages([
        //           ...errorMessages,
        //           "some thing went wrong try again",
        //         ]);
        //         setLoading(false);
        //       }
        //     } else {
        //       setLoading(false);
        //       setErrorMessages((prev) => [
        //         ...prev,
        //         "Amount Should be more than 0.",
        //       ]);
        //       setLoading(false);
        //     }
        //   } else {
        //     setLoading(false);
        //     setErrorMessages([walletSchemeDetails?.data?.message]);
        //   }
        // } else {
        //   setLoading(false);
        //   setErrorMessages([CheckingCreditCardLimit.error]);
      }
    } catch (error) {
      console.log("error in handleAddMoneyCardToWallet ==>", error);
      setLoading(false);
      setErrorMessages(["Please contact to Help Center"]);
    }
  };

  const handleCloseReceipt = async () => {
    setReceiptData({});
    setReceiptModal(false);
    navigate("/eduHistory", { replace: true });
  };

  if (receiptLoading || loading) {
    return <NtarLoader />;
  }

  // Account details resolution
  const senderName = userDetails?.userName || cardDetails?.senderName || "";
  const senderMobile =
    userDetails?.mobileNumber || cardDetails?.senderMobile || "";

  const beneficiaryName = cardDetails?.accountHolderName || cardDetails?.beneficiaryName || "";
  const beneficiaryBank = cardDetails?.bankName || "";
  const maskedAccountNumber = cardDetails?.accountNumber
    ? `****${cardDetails.accountNumber.slice(-4)}` : cardDetails?.beneficiaryAccountNumber ? `****${cardDetails.beneficiaryAccountNumber.slice(-4)}`
    : "";
  const beneficiaryMobile = cardDetails?.mobile || "";

  const handleBack = () => {
    if (
      cardDetails &&
      (cardDetails.accountHolderName ||
        cardDetails.accountNumber ||
        cardDetails.amount)
    ) {
      navigate("/EducationPay", { state: cardDetails });
    } else {
      navigate(-1);
    }
  };

  console.log("education ====>>", localStorage.getItem("dummyUserPhoneNo") ===
                        "9999999999")

  return (
    <>
      <Header title="Payment Checkout" />
      <div className="edu_checkout_container pay_pv_div_s">
        <div className="edu-checkout-page">
        {/* Top Header */}
        <div className="edu-checkout-header">
          <div className="edu-checkout-header-left">
            <button
              className="edu-checkout-back-btn"
              type="button"
              aria-label="Back"
              onClick={handleBack}
            >
              <KeyboardBackspaceIcon />
            </button>
            <div className="edu-checkout-title-wrap">
              <h2>Payment Checkout</h2>
              <p>Review details and pay securely</p>
            </div>
          </div>

          <span className="edu-secure-badge">
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
            </svg>
            Secure Payment
          </span>
        </div>

        {/* Main Side-by-Side Container */}
        <div className="edu-checkout-container">
          <div className="edu-checkout-card">
            <div
              className="edu-card-header"
              onClick={() => setAccountDetailsOpen(!accountDetailsOpen)}
            >
              <h3>Account Details</h3>
              {/* <button className="edu-card-toggle" type="button">
                {accountDetailsOpen ? (
                  <KeyboardArrowUpIcon />
                ) : (
                  <KeyboardArrowDownIcon />
                )}
              </button> */}
            </div>

            {accountDetailsOpen && (
              <div className="edu-account-details-body">
                <div className="edu-account-columns">
                  {/* Sender Details */}
                  <div className="edu-account-col">
                    <h4 className="edu-col-title">Sender Details</h4>

                    <div className="edu-detail-item">
                      <span className="edu-detail-label">Full Name</span>
                      <span className="edu-detail-value">{senderName || "DEMO"}</span>
                    </div>

                    <div className="edu-detail-item">
                      <span className="edu-detail-label">Mobile No</span>
                      <span className="edu-detail-value">{senderMobile}</span>
                    </div>
                  </div>

                  {/* Beneficiary Details */}
                  <div className="edu-account-col">
                    <h4 className="edu-col-title">Beneficiary Details</h4>

                    <div className="edu-detail-item">
                      <span className="edu-detail-label">Beneficiary Name</span>
                      <span className="edu-detail-value">
                        {beneficiaryName}
                      </span>
                    </div>

                    {/* <div className="edu-detail-item">
                      <span className="edu-detail-label">Bank Name</span>
                      <span className="edu-detail-value">
                        {beneficiaryBank}
                      </span>
                    </div> */}

                    <div className="edu-detail-item">
                      <span className="edu-detail-label">Account Number</span>
                      <span className="edu-detail-value">
                        {maskedAccountNumber}
                      </span>
                    </div>

                    <div className="edu-detail-item">
                      <span className="edu-detail-label">Mobile Number</span>
                      <span className="edu-detail-value">
                        {beneficiaryMobile}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="edu-checkout-card">
            <div
              className="edu-card-header"
              onClick={() => setCardDetailsOpen(!cardDetailsOpen)}
            >
              <h3>Card Details</h3>
              {/* <button className="edu-card-toggle" type="button">
                {cardDetailsOpen ? (
                  <KeyboardArrowUpIcon />
                ) : (
                  <KeyboardArrowDownIcon />
                )}
              </button> */}
            </div>

            {cardDetailsOpen && (
              <div className="edu-card-details-body">
                {errorMessages.length > 0 && (
                  <Box
                    sx={{
                      color: "var(--red)",
                      fontSize: "14px",
                      textAlign: "center",
                      mb: 2,
                    }}
                  >
                    {errorMessages.map((error, index) => (
                      <Typography key={index} variant="body2">
                        {error}
                      </Typography>
                    ))}
                  </Box>
                )}

                {cardNumber ? (
                  <p className="credit_type_s">{`${cardNumber} Credit Card`}</p>
                ) : null}

                <div className="addamount-creditCard_details_s">
                  <div>
                    {enteredDetails?.creditCardNumber?.length === 19 &&
                    enteredDetails?.cvv?.length === 3 ? (
                      ""
                    ) : (
                      <div className="creditCard_number_s">
                        <div className="accountnum-input_group_s">
                          <div className="Addamount-cardnumber-v">
                            <span
                              className={
                                enteredDetails?.creditCardNumber?.length > 0 &&
                                enteredDetails?.creditCardNumber !==
                                  "XXXXXXXXXXXXXXXX"
                                  ? "bound_icon_change_s"
                                  : "bound_icon_s"
                              }
                            >
                              <img
                                src={ImagesPath?.GetPaidAddamount?.cardNumImg}
                                alt="No Image"
                              />
                            </span>
                            <input
                              type="text"
                              id="creditCardNumber"
                              name="creditCardNumber"
                              maxLength="19"
                              value={formatCreditCardNumber(
                                enteredDetails?.creditCardNumber || "",
                              )}
                              onChange={(e) =>
                                handleInputChange(
                                  "creditCardNumber",
                                  e.target.value,
                                )
                              }
                              onBlur={() =>
                                validateCreditCard(
                                  enteredDetails?.creditCardNumber,
                                )
                              }
                              placeholder="Enter Credit Card number*"
                              className="addamount-input_field_s"
                              onKeyUp={(e) => {
                                if (
                                  e.target.value.replace(/\s/g, "").length ===
                                  16
                                ) {
                                  moveToNextField("creditCardNumber");
                                }
                              }}
                              autoComplete="off"
                            />
                          </div>
                          {brand && brand === "VISA" ? (
                            <img
                              src={ImagesPath?.GetPaidAddamount?.visa}
                              alt="Visa"
                            />
                          ) : brand && brand.includes("RUPAY") ? (
                            <img
                              src={ImagesPath?.GetPaidAddamount?.rupay}
                              alt="RuPay"
                            />
                          ) : brand && brand === "MASTERCARD" ? (
                            <img
                              src={ImagesPath?.GetPaidAddamount?.master}
                              alt="MasterCard"
                            />
                          ) : null}
                        </div>
                        {fieldErrors?.creditCardNumber && (
                          <p className="error_cardNum_s">
                            {fieldErrors.creditCardNumber}
                          </p>
                        )}

                        <div className="addamount-cvv_MM_s">
                          <div className="input_group_sp_s">
                            <span
                              className={
                                enteredDetails?.monthAndYear
                                  ? "bound_icon_change_s"
                                  : "bound_icon_s"
                              }
                            >
                              <img
                                src={ImagesPath?.GetPaidAddamount?.monthImg}
                                alt="No Image"
                              />
                            </span>
                            <input
                              type="text"
                              name="monthAndYear"
                              id="monthAndYear"
                              value={enteredDetails?.monthAndYear}
                              onChange={(e) => {
                                let value = e.target.value;
                                if (
                                  value.length === 2 &&
                                  !value.includes("/")
                                ) {
                                  value += "/";
                                }
                                if (!/^[0-1]?[0-9]?(\/\d{0,2})?$/.test(value)) {
                                  return;
                                }
                                handleInputChange("monthAndYear", value);
                                if (
                                  value.length === 5 &&
                                  /^(0[1-9]|1[0-2])\/\d{2}$/.test(value)
                                ) {
                                  moveToNextField("monthAndYear");
                                }
                              }}
                              onKeyDown={(e) => {
                                const value = enteredDetails?.monthAndYear;
                                if (
                                  e.key === "Backspace" &&
                                  value?.length === 3 &&
                                  value[2] === "/"
                                ) {
                                  const newValue = value.slice(0, 2);
                                  handleInputChange("monthAndYear", newValue);
                                  e.preventDefault();
                                }
                              }}
                              placeholder="MM/YY*"
                              className="input_field_special_s"
                            />
                          </div>

                          <div className="input_group_sp_s">
                            <span
                              className={
                                enteredDetails?.cvv
                                  ? "bound_icon_change_s"
                                  : "bound_icon_s"
                              }
                            >
                              <img
                                src={ImagesPath?.GetPaidAddamount?.cardNumImg}
                                alt="No Image"
                              />
                            </span>
                            <input
                              type={showCvv ? "text" : "password"}
                              name="cvv"
                              id="cvv"
                              value={enteredDetails?.cvv}
                              onChange={(e) => {
                                const { value } = e.target;
                                handleInputChange("cvv", value);
                                if (value.length === 3) {
                                  moveToNextField("cvv");
                                }
                              }}
                              maxLength="3"
                              placeholder="CVV*"
                              className="input_field_special_s"
                            />
                            <p
                              onClick={() => setShowCvv(!showCvv)}
                              className="Eye_icon_s"
                              style={{ cursor: "pointer" }}
                            >
                              {showCvv ? <VisibilityOff /> : <Visibility />}
                            </p>
                          </div>
                        </div>
                        {fieldErrors?.cvv && (
                          <p className="error_cardNum_s">{fieldErrors.cvv}</p>
                        )}
                        {fieldErrors?.monthAndYear && (
                          <p className="error_cardNum_s">
                            {fieldErrors.monthAndYear}
                          </p>
                        )}

                        <div className="input_group_gp_s">
                          <span
                            className={
                              enteredDetails?.mobileNumber
                                ? "bound_icon_change_s"
                                : "bound_icon_s"
                            }
                          >
                            <img
                              src={ImagesPath?.GetPaidAddamount?.mobileCardImg}
                              alt="No Image"
                            />
                          </span>
                          <input
                            type="text"
                            name="mobileNumber"
                            id="mobileNumber"
                            maxLength="10"
                            value={enteredDetails?.mobileNumber}
                            onChange={(e) => {
                              const { value } = e.target;
                              handleInputChange(
                                "mobileNumber",
                                value.replace(/\D/g, ""),
                              );
                              if (value.length === 10) {
                                moveToNextField("mobileNumber");
                              }
                            }}
                            placeholder="Enter Phone Number*"
                            className="addamount-input_field_s"
                          />
                        </div>
                        {fieldErrors?.mobileNumber && (
                          <p className="error_cardNum_s">
                            {fieldErrors.mobileNumber}
                          </p>
                        )}
                      </div>
                    )}
                  </div>

                  <div className="input_group_gp_s">
                    <span
                      className={
                        enteredDetails?.holderName
                          ? "bound_icon_change_s"
                          : "bound_icon_s"
                      }
                    >
                      <img
                        src={ImagesPath?.GetPaidAddamount?.personCardImg}
                        alt="No Image"
                      />
                    </span>
                    <input
                      type="text"
                      name="holderName"
                      id="holderName"
                      value={enteredDetails?.holderName}
                      onChange={(e) =>
                        handleInputChange("holderName", e.target.value)
                      }
                      placeholder="Enter Name on Card*"
                      className="addamount-input_field_s"
                    />
                  </div>
                  {fieldErrors?.holderName && (
                    <p className="error_cardNum_s">{fieldErrors.holderName}</p>
                  )}
                  {cardError && <p className="error_cardNum_s">{cardError}</p>}
                  {!locationPermissionGiven && !loadingLocation && (
                    <p className="error_cardNum_s">
                      {locationError ||
                        "Please allow location in your browser."}
                    </p>
                  )}

                  <button
                    onClick={() => {
                      const isDummy =
                        localStorage.getItem("dummyUserPhoneNo") ===
                        "9999999999";
                      if (isDummy) {
                        console.log("dummy hitted")
                        handleDummyAddMoney();
                      } else {
                        handleAddMoneyCardToWallet();
                      }
                    }}
                    className="addamount-next_btn_s"
                    disabled={
                      loading ||
                      enteredDetails?.creditCardNumber?.length < 16 ||
                      enteredDetails?.cvv?.length !== 3 ||
                      enteredDetails?.mobileNumber?.length !== 10 ||
                      !enteredDetails?.monthAndYear ||
                      !/^(0[1-9]|1[0-2])\/\d{2}$/.test(
                        enteredDetails?.monthAndYear,
                      ) ||
                      !/^[6-9]\d{9}$/.test(enteredDetails?.mobileNumber) ||
                      !enteredDetails?.holderName ||
                      errorMessages?.length > 0 ||
                      pluralLoading ||
                      !locationPermissionGiven ||
                      cardError
                    }
                  >
                    {loading || pluralLoading ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : (
                      `Pay ₹${enteredDetails?.actualAmount || 0}`
                    )}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        {receiptModal && (
          <div>
            <Receipt
              type={getPaymentStatus(receiptData)}
              receiptData={receiptData}
              handleClose={handleCloseReceipt}
              center={true}
            />
          </div>
        )}

        {enablePopups && <EnablePopupsGuide />}

        {isModalVisible && (
          <Modal
            title=""
            open={isModalVisible}
            closable={false}
            maskClosable={false}
            keyboard={false}
            footer={[
              <Button
                key="ok"
                className="button_gotIt"
                onClick={() => navigate(-1)}
              >
                Ok
              </Button>,
            ]}
          >
            <img
              src={NtarLogo}
              alt="Warning"
              style={{ width: "100px", display: "block", marginBottom: "10px" }}
            />
            <p
              style={{
                marginBottom: "6px",
                fontWeight: "bolder",
                fontSize: "14px",
              }}
            >
              Payment Gateway Error
            </p>
            <p>Something went wrong, please try again.</p>
          </Modal>
        )}
      </div>
    </div>
  </>
  );
};

export default EducationPaycheckout;
